module.exports = __webpack_public_path__ + "img/agent_logo.e0d718d9.png";